// extracted by mini-css-extract-plugin
export default {"closeButton":"cEk0y"};